import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_PATH = 'default';
const WINBACK_PATH = 'winback';

export default function useLocalStorage(path: string = DEFAULT_PATH) {
    const location = useLocation();
    const isWinback = useMemo(() => location.pathname.includes('lovely-user/winback'), [location.pathname]);

    const storagePath = isWinback ? WINBACK_PATH : path;

    const read = (key: string, defaultValue?: unknown) => {
        const storageKey = `${storagePath}.${key}`;
        const item = localStorage.getItem(storageKey);
        const parsedItem = item ? JSON.parse(item) : undefined;
        const result = parsedItem || defaultValue;
        return result;
    };

    const write = (key: string, value: unknown) => {
        const storageKey = `${storagePath}.${key}`;
        localStorage.setItem(storageKey, JSON.stringify(value));
    };

    const remove = (key: string) => {
        const storageKey = `${storagePath}.${key}`;
        localStorage.removeItem(storageKey);
    };

    const storage = {
        read,
        write,
        remove,
    };

    return storage;
}

// Earlier versions saved the whole step 1 form, password included, under
// authStepData. Strip the password from what is already in visitors' browsers;
// the rest stays, so an unfinished signup resumes where it was left.
export function removeStoredSignupPassword() {
    [DEFAULT_PATH, WINBACK_PATH].forEach((path) => {
        const storageKey = `${path}.authStepData`;
        try {
            const item = localStorage.getItem(storageKey);
            const data = item ? JSON.parse(item) : undefined;
            if (data && typeof data === 'object' && 'password' in data) {
                delete data.password;
                localStorage.setItem(storageKey, JSON.stringify(data));
            }
        } catch {
            // Storage blocked or the value is not JSON: nothing of ours to clean.
        }
    });
}
